// extracted by mini-css-extract-plugin
export var fromLeft = "modal-flyin-module--fromLeft--1484a";
export var fromRight = "modal-flyin-module--fromRight--57f74";
export var isOpen = "modal-flyin-module--isOpen--86365";
export var modalFlyIn = "modal-flyin-module--modalFlyIn--10e84";
export var modalFlyIn__close = "modal-flyin-module--modalFlyIn__close--aa5ac";
export var modalFlyIn__content = "modal-flyin-module--modalFlyIn__content--10192";
export var modalFlyIn__content__inner = "modal-flyin-module--modalFlyIn__content__inner--19e5f";
export var modalFlyIn__overlay = "modal-flyin-module--modalFlyIn__overlay--a577d";